import React from 'react'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
} from '@material-ui/core'
import Slider from 'react-slick'
import { useHistory } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import './machinesCarousel.scss'

const MachinesCarousel = () => {
  const history = useHistory()

  const MachineSlide = ({ img, name, description, url }) => {
    return (
      <div>
        <Card
          style={{
            backgroundImage: `url(images/homepage/machines/${img})`,
          }}
        >
          <CardContent>
            <div className="content">
              <h4>{name}</h4>
              <p>{description}</p>
            </div>
            <CardActions>
              <a href={url} target="_blank" rel="noreferrer">
                <Button className="btn-white">Learn More</Button>
              </a>
            </CardActions>
          </CardContent>
        </Card>
      </div>
    )
  }

  const ArrowLeft = (props) => (
    <Button {...props} className={'arrow prev'}>
      <ChevronLeft />
    </Button>
  )
  const ArrowRight = (props) => (
    <Button {...props} className={'arrow next'}>
      <ChevronRight />
    </Button>
  )

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <section
      className="machines"
      style={{
        backgroundImage: 'url(images/butterfly-bg.png)',
      }}
    >
      <Container style={{ minHeight: 'unset' }}>
        <Grid container spacing={6} className="m-b-5">
          <Grid item md={6} xs={12}>
            <h3>Machines</h3>
            <p>A selection of systems that we use in our solution centers</p>
          </Grid>
          <Grid item md={6} xs={12} style={{ textAlign: 'right' }}>
            <Button
              className="btn-gradient dark"
              onClick={() => history.push('/createaquote')}
            >
              Start a quote
            </Button>
          </Grid>
        </Grid>

        <Slider {...settings}>
          <MachineSlide
            img="global-s.jpg"
            name="GLOBAL S"
            description="The GLOBAL S coordinate measuring machine (CMM) delivers measurement productivity tailored to your workflow, addressing the widest range of production requirements including throughput, precision, multi-purpose and shop-floor capabilities."
            url="https://www.hexagonmi.com/en-us/products/coordinate-measuring-machines/bridge-cmms/global-s"
          />
          <MachineSlide
            img="optiv-performance.jpg"
            name="Optiv Performance"
            description="The Optiv Performance line can tackle many measuring tasks with its robust design in granite, its axes with mechanical bearings and complete range of sensors. This versatile CMM is the first choice for measuring a range of workpieces – both in the quality room and in the production area."
            url="https://www.hexagonmi.com/en-us/products/coordinate-measuring-machines/multisensor-and-optical-cmms/optiv-performance"
          />
          <MachineSlide
            img="absolute-arm.jpg"
            name="Absolute Arm 7-Axis"
            description="The Absolute Arm 7-Axis delivers tactile probing and non-contact scanning in a uniquely ergonomic package. With usability central to its design, this is an articulating measuring arm that can’t be beaten when it comes to ease of movement and ease of measurement."
            url="https://www.hexagonmi.com/en-us/products/portable-measuring-arms/absolute-arm-7-axis"
          />
          <MachineSlide
            img="7-10-7.jpg"
            name="7.10.7 SF"
            description="The 7.10.7 SF is a rugged and robust coordinate measuring machine designed to excel in demanding conditions. With additional features to increase usability and offer a better user experience for shop-floor operators, the 7.10.7 SF is ideal for frontline quality control."
            url="https://www.hexagonmi.com/en-us/products/coordinate-measuring-machines/shop-floor-cmms/7107-sf"
          />
        </Slider>
      </Container>
    </section>
  )
}

export default MachinesCarousel
